import React from "react";

function Pagination({
  totalPages = 1,
  currentPage,
  onPageChange,
  showing = 10,
  total = 10
}) {
  const onpageChange = (page) => {
    if (page !== currentPage) {
      onPageChange(page);
    }
  };
  const handlePrevious = () => {
    if (currentPage > 1) {
      onpageChange(currentPage - 1);
    }
  };
  const handleNext = () => {
    if (currentPage < totalPages) {
      onpageChange(currentPage + 1);
    }
  };
  const handlePageClick = (page) => {
    onpageChange(page);
  };
  return (
    <div className="mt-4 flex items-center justify-between">
      <div className="text-sm text-gray-500">
        {total > 0 ? (
          <>
            Showing {(currentPage - 1) * showing + 1} &nbsp;–&nbsp; 
            {Math.min(currentPage * showing, total)} of {total} records
          </>
        ) : (
          <>Showing 0 of 0 records</>
        )}
      </div>
      <div className="flex space-x-2">
        <button
          onClick={handlePrevious}
          className="px-3 py-1 border rounded text-sm font-medium hover:bg-gray-50"
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            onClick={() => handlePageClick(index + 1)}
            className={`px-3 py-1 border rounded text-sm font-medium ${
              currentPage === index + 1 ? "bg-gray-200" : "hover:bg-gray-50"
            }`}
          >
            {index + 1}
          </button>
        ))}
        <button
          onClick={handleNext}
          className="px-3 py-1 border rounded text-sm font-medium hover:bg-gray-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Pagination;
